module.exports = __webpack_public_path__ + "img/thami-profile-min.3f86dd8d.jpg";